var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextTile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D4C59",
    d: "M14.5 4c.828 0 1.5.672 1.5 1.5 0 .78-.595 1.42-1.356 1.493L14.5 7H10v12.5c0 .828-.672 1.5-1.5 1.5-.78 0-1.42-.595-1.493-1.356L7 19.5V7H2.5C1.672 7 1 6.328 1 5.5c0-.78.595-1.42 1.356-1.493L2.5 4h12z",
    transform: "translate(-109 -97) translate(109 97)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8995A0",
    d: "M21 19c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 21h-8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L13 19h8zm-2-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L19 17h-6c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L13 15h6zm3-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L22 13h-9c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L13 11h9z",
    transform: "translate(-109 -97) translate(109 97)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTile);
export default __webpack_public_path__ + "static/media/textTile.9768730e.svg";
export { ForwardRef as ReactComponent };